import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FilterModel } from '../../models/filter/filter-request.model';
import { FilterResponseModel } from '../../models/filter/filter-response.model';
import { GlobalService } from '../../services/global.service';
import { CommonConstants, FilterFieldTypes } from '../common-constants';

@Component({
  selector: 'app-add-filter',
  templateUrl: './add-filter.component.html',
  styleUrls: ['./add-filter.component.css']
})
export class AddFilterComponent implements OnInit {

  @Input() filterList: FilterModel[];
  @Input() selectedFilters: FilterResponseModel[];
  @Output() filterResponse = new EventEmitter();

  public conditionList: string[];
  public valuesList: string[];
  public constants: CommonConstants;

  public addFilterForm: UntypedFormGroup;

  constructor(public fb: UntypedFormBuilder, private readonly globalService: GlobalService) { }

  ngOnInit(): void {
    this.constants = new CommonConstants();
    this.addFilterForm = this.fb.group({
      filterName: ['', Validators.required],
      condition: ['', Validators.required],
      value: ['', Validators.required]
    });
  }

  /** Triggered when field is selected*/
  onFieldSelected() {
    this.valuesList = [];
    let selectedField = this.addFilterForm.get('filterName').value;
    this.addFilterForm.reset();
    this.addFilterForm.get('filterName').setValue(selectedField);
    let tempType = this.filterList.find(o => o.fieldName === this.addFilterForm.get('filterName').value.fieldName);
    switch (tempType.fieldType) {
      case FilterFieldTypes.text:
        this.conditionList = this.constants.conditionTypeText;
        break;
      case FilterFieldTypes.values:
        this.conditionList = this.constants.conditionTypeValues;
        break;
    }
  }

  /**
   * Receive user input and send to search method
   * @param value
   */

  /**When condition is selected */
  onConditionSelected() {
    let tempType = this.filterList.find(o => o.fieldName === this.addFilterForm.get('filterName').value.fieldName);
    if (tempType.fieldType == "text") {
      this.valuesList = [...tempType.values].filter(n => n).sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
    } else if (tempType.fieldType == "values") {
      this.valuesList = [...tempType.values].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
    }
  }

  /**
   * Hides field name from dropdown
   * @param fieldName
   */
  hideFieldName(fieldName: string) {
    return (fieldName !== "version" && this.selectedFilters?.find(t => t.selectedFieldName == fieldName));
  }

  /**
   * Disables value
   * @param element
   */
  disableValues(element: string) {
    let check: boolean = (!this.addFilterForm.get('value').value?.includes(element) && this.addFilterForm.get('value').value?.length >= 5);
    return check;
  }

  /**Adding a new filter */
  submitFilter() {
    let response: FilterResponseModel = new FilterResponseModel();
    response.selectedFieldName = this.globalService.replaceFilterText(this.addFilterForm.get('filterName').value.fieldName);
    response.selectedCondition = this.addFilterForm.get('condition').value;
    response.selectedValue = this.addFilterForm.get('value').value;
    this.filterResponse.emit({ filterResponse: response });
  }
  
}
